var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-qr-code-form',{ref:"form",staticClass:"pt-qr-code-form__withData",attrs:{"groupList":_vm.groupList}})}
var staticRenderFns = []

export { render, staticRenderFns }